import { render, staticRenderFns } from "./allege.vue?vue&type=template&id=80a13266&scoped=true&"
import script from "./allege.vue?vue&type=script&lang=js&"
export * from "./allege.vue?vue&type=script&lang=js&"
import style0 from "./allege.vue?vue&type=style&index=0&id=80a13266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a13266",
  null
  
)

export default component.exports